window.devmode = window.devmode || false;
window.stopRedirect = false;
(function($) {
  $(document).ready(function() {
    function getGaList() {
      var pathname = window.location.pathname;

      var name = pathname.substring(1).replace('/', '__');
      if (pathname.startsWith('/')) {
        name = 'homepage';
      }
      if (pathname.startsWith('/blog')) {
        name = 'blogpage';
      }
      return {
        id: pathname,
        name: name,
      };
    }
    if ($('.productimpression').length) {
      var productImpressionList = [];

      var productImpression = $('.productimpression');

      productImpression.each(function(i) {
        var productPosition = i + 1;

        var productId = $(this).data('impressionid');
        var productName = $(this).data('impressionname');
        var productPrice = $(this).data('impressionprice');
        var productCategory = $(this).data('impressioncategory');
        var gaList = getGaList();

        productImpressionList.push({
          item_id: productId,
          item_name: productName,
          currency: 'USD',
          index: productPosition,
          item_brand: 'Todd Shelton',
          item_category: productCategory,
          item_list_id: gaList.id,
          item_list_name: gaList.name,
          price: productPrice,
          quantity: 1,
        });

        $(this).on('click', 'a', function(e) {
          if (!devmode) {
            if (!!window.google_tag_manager) {
              e.preventDefault();
            }
          }
          var productId = $(this)
            .closest('.productimpression')
            .data('impressionid');
          var productName = $(this)
            .closest('.productimpression')
            .data('impressionname');
          var productPrice = $(this)
            .closest('.productimpression')
            .data('impressionprice');
          var productCategory = $(this)
            .closest('.productimpression')
            .data('impressioncategory');
          var redirecturl = $(this).attr('href');

          window.dataLayer = window.dataLayer || [];
          //console.log(redirecturl);
          var gaList = getGaList();
          dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
          dataLayer.push({
            event: 'select_item',
            ecommerce: {
              items: [
                {
                  item_id: productId,
                  item_name: productName,
                  currency: 'USD',
                  index: productPosition,
                  item_brand: 'Todd Shelton',
                  item_category: productCategory,
                  item_list_id: gaList.id,
                  item_list_name: gaList.name,
                  price: productPrice,
                  quantity: 1,
                },
              ],
            },
            eventCallback: function() {
              document.location = redirecturl;
            },
          });
        });
      });

      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          items: productImpressionList,
        },
      });
    }
    if ($('.ee-productclick').length) {
      $('.ee-productclick').each(function() {
        var productId = $(this).data('impressionid');
        var productName = $(this).data('impressionname');
        var productPrice = $(this).data('impressionprice');
        var productCategory = $(this).data('impressioncategory');

        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: 'view_item',
          ecommerce: {
            items: [
              {
                item_id: productId,
                item_name: productName,
                currency: 'USD',
                index: 0,
                item_brand: 'Todd Shelton',
                item_category: productCategory,
                price: productPrice,
                quantity: 1,
              },
            ],
          },
        });
      });
    }

    if ($('.ee-cartaddremove').length) {
      $('.shopping-bag-form').on(
        'eeAddRemove',
        '.ee-cartaddremove',
        function(e, changedType, count, redirecturl) {
          var productId = $(this).data('impressionid');
          var productName = $(this).data('impressionname');
          var productPrice = $(this).data('impressionprice');
          var productCategory = $(this).data('impressioncategory');

          window.dataLayer = window.dataLayer || [];

          if (changedType === 'plus') {
            dataLayer.push({
              event: 'addToCart',
              ecommerce: {
                currencyCode: 'USD',
                add: {
                  products: [
                    {
                      id: productId,
                      name: productName,
                      price: productPrice,
                      category: productCategory,
                      brand: 'Todd Shelton',
                      quantity: count,
                    },
                  ],
                },
              },
            });
            // console.log(dataLayer[dataLayer.length-1]);
          }
          if (changedType === 'minus') {
            var dataLayerObj = {
              event: 'remove_from_cart',
              ecommerce: {
                items: [
                  {
                    item_id: productId,
                    item_name: productName,
                    currency: 'USD',
                    index: 0,
                    item_brand: 'Todd Shelton',
                    item_category: productCategory,
                    price: productPrice,
                    quantity: count,
                  },
                ],
              },
            };

            if (typeof redirecturl !== 'undefined') {
              dataLayerObj['eventCallback'] = function() {
                if (stopRedirect) return;
                document.location = redirecturl;
                window.stopRedirect = true;
              };
            }
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push(dataLayerObj);

            if (devmode) {
              document.location = redirecturl;
            }
            //console.log(dataLayer[dataLayer.length-1]);
          }
        }
      );
    }
  });
})(jQuery);
